import React from 'react';
import { Box, Typography } from '@mui/material';
import '@fontsource/be-vietnam-pro/900.css';

const Banner = ({ url, title, description, align = 'center', width = '100%' }) => {

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: 300,
        backgroundImage: `url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: align === 'center' ? 'center' : 'flex-start',
        color: 'white',
        textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
        px: align === 'left' ? { xs: 2, md: 6 } : 0,
      }}
    >

      <Box sx={{ maxWidth: width }}>
        {/* Vạch đỏ */}
        <Box sx={{ width: 6, height: '100%', backgroundColor: 'red', mb: 1 }} />

        {/* Tiêu đề */}
        <Box
          sx={{
            maxWidth: width,
            position: 'relative',
            zIndex: 2,
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Be Vietnam Pro", sans-serif',
              fontWeight: 900,
              fontSize: { xs: '36px', md: '48px' },
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Be Vietnam Pro", sans-serif',
              fontWeight: 400,
              fontSize: { xs: '18px', md: '24px' },
              mt: 1
            }}
          >
            TỪ NHỮNG TRANG SỬ ĐỎ
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Be Vietnam Pro", sans-serif',
              fontWeight: 400,
              fontSize: { xs: '18px', md: '24px' },
              mt: 0
            }}
          >
            ĐẾN NHỮNG NHỊP TIM XANH
          </Typography>
        </Box>

        {/* Mô tả (nếu có) */}
        {description && (
          <Typography sx={{ mt: 1, fontSize: 16 }}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};


export default Banner;
